import { Deserializable } from '../../protocols/deserializable';
import { EmploymentStatusChangeReasonId } from '../../employers/enum/employment-status-change-reason-id';

export class UpdateEmploymentStatusSubmissionData implements Deserializable {
  public memberId!: number;
  public employmentStatusChangeReasonId!: EmploymentStatusChangeReasonId;
  public endDate!: string;
  public totalEmploymentIncome!: number;
  public totalPlanContributions!: number;
  public employeeMatchedAmount!: number;
  public employerMatchedAmount!: number;
  public employeeVoluntaryAmount!: number;
  public employerUnmatchedAmount!: number;
  public lastExpectedContributionDate!: string;
  public notes!: string | null;

  public onDeserialize(): void {}
}
